export default {
  title: 'Dettagli codice promo',
  back: 'Torna ai codici promo',
  tabs: {
    customers: 'Clienti',
    orders: 'Ordini',
  },
  metrics: {
    gmv: 'GMV',
    average_order_value: 'Valore medio ordine',
    customer_adoption: 'Clienti unici',
  },
  toasts: {
    failed_to_load_stats: 'Caricamento statistiche non riuscito',
  },
};
